import events from '../../events.json'

/**
 * transformAggregatorData
 *
 * @description returns data object structured for lumber logging
 */

export function transformAggregatorDataForLumber (aggregatorData) {
  const {
    sdkData,
    methodName,
    userAgent
  } = aggregatorData

  try {
    // returns array of objects structured for lumber
    return sdkData.map(sdkDataObject => {
      const networkId = Object.keys(sdkDataObject)[0]
      const {
        status,
        response,
        responseTime
      } = sdkDataObject[networkId]

      const responseInfo = adaptForRemoteLogging(status, response, methodName)
      // lumber will add other constants to details property and remove undefined properties
      return {
        ...events.infos.PERF_DATA,
        details: {
          methodName,
          status,
          responseInfo,
          userAgent,
          networkId,
          responseTime
        }
      }
    })
  } catch (error) {
    // in the event of error, returns single object for lumber.error
    return {
      ...events.errors.PERF_DATA,
      details: {
        message: 'Could not log SDK performance data',
        error: error.message
      }
    }
  }
}

/**
 * adaptForRemoteLogging
 *
 * @description filters SDK method response data for remote logging
 */

function adaptForRemoteLogging (status, response, methodName) {
  if (status === 'rejected') {
    const {
      reason,
      message,
      status
    } = response

    return {
      reason: reason || message || status
    }
  }

  // removes all response data except for a few specific properties
  let responseInfo
  switch (methodName) {
    case 'isRecognized':
      const { recognized } = response
      if (recognized !== undefined) responseInfo = { recognized }
      break
    case 'identityLookup':
      const { consumerPresent } = response
      if (consumerPresent !== undefined) responseInfo = { consumerPresent }
      break
    case 'getSrcProfile':
      const { profiles } = response
      if (profiles !== undefined) responseInfo = { profiles: !!profiles.length }
      break
  }

  return responseInfo
}
